/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Header
import Header from '../header';

function Hero(props) {
    return (
        <div className="home-hero mb-10">
            <Header />
            <div className="content max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 py-5 pt-40">
                <h2 className="text-gray-300 text-center text-2xl font-semibold mb-7">{props.subtitle}</h2>
                <h1 className="text-gray-200 text-center text-5xl font-semibold mb-8">{props.title}</h1>
                <p className="text-gray-300 text-center text-base">{props.description}</p>
            </div>
        </div>
    )
}

export default Hero